/**
 * Created by piotr@revisual.io on 08/08/2026
 */
import PageTemplate from "../../../templates/PageTemplate";
import EventAnalyticsContainer from "./EventAnalyticsContainer";
require("./../../../../../local_modules/event-analytics/src/EventAnalytics.scss");
const EventEngagementPage = () => {
  return (
    <PageTemplate
      sidebarId="eventEngagement"
      title={"Reports: Event Engagement"}
      icon={"insights"}
      headerControls={""}
    >
      <div className="card-box">
        <EventAnalyticsContainer />
      </div>
    </PageTemplate>
  );
};

export default EventEngagementPage;
